module.exports = __webpack_public_path__ + "img/photo-camera.8c21d9f8.svg";